module.exports = __webpack_public_path__ + "img/7.d78430ae.png";